
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinakurdipune() {



    const cardData =
    {
        keyword: 'Cab Service in Akurdi Pune',
        heading: 'Platinum24 Cabs: Cab Service in Akurdi Pune',
        headingDescription: ' Platinum24 Cabs offers dependable Cab Service in Akurdi Pune, ensuring safe, comfortable, and affordable rides for residents, students, and working professionals in this key PCMC locality. Our fleet of hatchbacks, sedans, SUVs, and luxury cars provides reliable travel options for local commutes, airport transfers, corporate travel, and outstation trips. With professional chauffeurs, punctual pickups, and transparent fares, we make travel in and around Akurdi stress-free. Whether it’s a short city ride, a family outing, or a long-distance journey, Platinum24 Cabs guarantees 24/7 availability and trustworthy cab services in Akurdi Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


       "services": [
    {
      "name": "Akurdi Cab Service",
      "description": "Discover reliable and comfortable transportation with our Akurdi Cab Service. Whether you're commuting daily or need a ride for special occasions, our fleet of clean and well-maintained vehicles combined with professional drivers ensures a safe and pleasant travel experience throughout Akurdi."
    },
    {
      "name": "Taxi Service Akurdi Pune",
      "description": "Our Taxi Service in Akurdi Pune offers convenient and affordable rides for all your travel needs. With punctual pickups, courteous drivers, and modern vehicles, we provide seamless transportation across Akurdi and nearby areas, making your daily commute or occasional trips hassle-free."
    },
    {
      "name": "Cab Booking Akurdi",
      "description": "Book your cab in Akurdi easily through our intuitive online platform or phone service. Enjoy quick confirmations and flexible scheduling, whether you need a cab immediately or plan your trip in advance, ensuring dependable rides tailored to your timing and preferences."
    },
    {
      "name": "Akurdi Local Taxi",
      "description": "Travel around Akurdi effortlessly with our Local Taxi service. Perfect for errands, shopping, and city commutes, our local taxis operate 24x7, providing safe, timely, and affordable rides with drivers familiar with the best routes to get you where you need to go quickly."
    },
    {
      "name": "Affordable Taxi Akurdi Pune",
      "description": "Access quality transportation without stretching your budget. Our Affordable Taxi services in Akurdi Pune offer competitive pricing, regular promotions, and transparent fare structures, allowing you to enjoy comfortable and safe rides at great value."
    },
    {
      "name": "Akurdi Taxi with Driver",
      "description": "Experience stress-free travel with our Akurdi Taxi service that includes professional, courteous drivers committed to your safety and convenience. Our drivers know the local routes well, ensuring efficient journeys whether for short city rides or longer trips."
    },
    {
      "name": "Akurdi Airport Taxi",
      "description": "Ensure timely arrivals and departures with our Akurdi Airport Taxi service. Available round the clock, we provide reliable airport transfers to Pune and other nearby airports, equipped with spacious vehicles and professional drivers to handle your luggage and schedule."
    },
    {
      "name": "Cab Rental Akurdi",
      "description": "Rent a cab in Akurdi for flexible durations, whether for day trips, corporate events, or weekend getaways. Our rental packages are customizable, offering a range of vehicle options with experienced drivers who prioritize your comfort and safety throughout the journey."
    },
    {
      "name": "Cab Service Near Me Akurdi",
      "description": "Find trusted and nearby cab services in Akurdi instantly. Our vast network of taxis ensures quick dispatch times and reliable service wherever you are, making it easy to get a ride when you need it most."
    },
    {
      "name": "Akurdi Outstation Taxi",
      "description": "Plan your outstation travels conveniently with our Akurdi Outstation Taxi service. Whether for leisure trips or business travel, enjoy comfortable rides with professional drivers, transparent pricing, and flexible booking options to suit your itinerary."
    },
    {
      "name": "Akurdi Corporate Taxi",
      "description": "Our Corporate Taxi services in Akurdi cater to businesses requiring reliable, punctual, and professional transportation solutions. Tailored packages, discreet service, and experienced chauffeurs help streamline your corporate travel needs efficiently."
    },
    {
      "name": "Akurdi Taxi Deals",
      "description": "Take advantage of special Akurdi Taxi Deals offering discounted rates and exclusive packages for frequent travelers, corporate clients, and long-distance rides. Enjoy premium taxi services at budget-friendly prices, making every journey more affordable."
    },
    {
      "name": "Akurdi City Taxi",
      "description": "Navigate Akurdi city with ease using our City Taxi service. Whether for sightseeing, errands, or meetings, our taxis provide reliable, safe, and comfortable transport options throughout the city with professional drivers dedicated to excellent service."
    },
    {
      "name": "Akurdi Family Taxi Service",
      "description": "Travel safely with your loved ones using our Family Taxi Service in Akurdi. Offering spacious and clean vehicles along with courteous drivers, this service is perfect for family outings, school runs, or group trips ensuring comfort and convenience for all passengers."
    },
    {
      "name": "Taxi Booking Online Akurdi",
      "description": "Book your Akurdi taxi online anytime through our secure and user-friendly platform. Experience instant booking confirmations, flexible payment options, and 24x7 customer support, ensuring a seamless and reliable ride whenever you need it."
    }
  ],
  "tableData": [
    ["Akurdi Cab Service", "Taxi Service Akurdi Pune"],
    ["Cab Booking Akurdi", "Akurdi Local Taxi"],
    ["Affordable Taxi Akurdi Pune", "Akurdi Taxi with Driver"],
    ["Akurdi Airport Taxi", "Cab Rental Akurdi"],
    ["Cab Service Near Me Akurdi", "Akurdi Outstation Taxi"],
    ["Akurdi Corporate Taxi", "Akurdi Taxi Deals"],
    ["Akurdi City Taxi", "Akurdi Family Taxi Service"],
    ["Taxi Booking Online Akurdi", "—"]
  ],


      "whychoose": [
    {
      "WhyChooseheading": "Reliable Cab Service in Akurdi Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers prompt and trustworthy cab services throughout Akurdi for all your local and outstation travel needs."
    },
    {
      "WhyChooseheading": "Quick and Convenient Pickup",
      "WhyChoosedescription": "Our drivers are always nearby to ensure timely pickups and smooth rides in Akurdi Pune."
    },
    {
      "WhyChooseheading": "Clean and Comfortable Vehicles",
      "WhyChoosedescription": "Travel safely in sanitized, air-conditioned cabs designed to provide maximum comfort."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Local Route Expertise",
      "WhyChoosedescription": "Our professional drivers know Akurdi’s roads well to avoid traffic and ensure timely arrivals."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Enjoy upfront pricing with no hidden fees, including fuel, tolls, and driver allowances."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Booking",
      "WhyChoosedescription": "Our support team is available around the clock to assist with bookings and travel inquiries."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for Local and Outstation Trips",
      "WhyChoosedescription": "Choose from hourly rentals, point-to-point rides, or long-distance journeys tailored to your needs."
    },
    {
      "WhyChooseheading": "Variety of Vehicle Options to Suit Your Group Size",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers for comfortable travel."
    }
  ]

























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services in Akurdi, Pune?',
        answer: 'Yes, Platinum24 Cabs provides reliable and convenient cab services in Akurdi, Pune for local commuting and outstation travel.',
    },
    {
        question: 'How can I book a cab service in Akurdi Pune with Platinum24 Cabs?',
        answer: 'You can easily book your cab through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for cab services in Akurdi Pune?',
        answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel needs.',
    },
    {
        question: 'Can I book cabs for both local and outstation travel from Akurdi?',
        answer: 'Yes, Platinum24 Cabs provides cab services for both local travel within Akurdi and outstation trips from Akurdi to other destinations.',
    },
    {
        question: 'Are the drivers experienced and knowledgeable about Akurdi routes?',
        answer: 'Absolutely. Our drivers are professional, licensed, and familiar with Akurdi and surrounding areas to ensure safe and timely travel.',
    },
    {
        question: 'Is hourly cab rental available in Akurdi Pune?',
        answer: 'Yes, hourly rental packages are available for local cab hire in Akurdi Pune.',
    },
    {
        question: 'Are safety and hygiene protocols followed for cab services in Akurdi?',
        answer: 'All vehicles are regularly sanitized, and drivers adhere to strict safety guidelines to protect passengers.',
    },
    {
        question: 'Is cab service in Akurdi Pune available 24x7?',
        answer: 'Yes, Platinum24 Cabs offers 24x7 cab booking and services in Akurdi Pune for your convenience.',
    },
    {
        question: 'What payment methods are accepted for cab bookings in Akurdi?',
        answer: 'We accept cash, digital payments, UPI, and card payments for hassle-free transactions.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Akurdi Pune?',
        answer: 'Yes, you can specify any pickup and drop-off points within Akurdi as per your travel plans.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sanjay Kulkarni',
        feedback: 'The cab service in Akurdi by Platinum24 Cabs was punctual and comfortable. Highly recommended!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Meena Joshi',
        feedback: 'Great experience with local cab service in Akurdi. The driver was professional and the vehicle clean.',
        rating: 5,
    },
];

































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];










const akurdiTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable cab service in Akurdi Pune offering local, airport, outstation, corporate, and family taxi services with professional drivers available for easy booking.",
  "areaServed": {
    "@type": "Place",
    "name": "Akurdi, Pune"
  },
  "serviceType": [
    "Akurdi Cab Service",
    "Taxi Service Akurdi Pune",
    "Cab Booking Akurdi",
    "Akurdi Local Taxi",
    "Affordable Taxi Akurdi Pune",
    "Akurdi Taxi with Driver",
    "Akurdi Airport Taxi",
    "Cab Rental Akurdi",
    "Cab Service Near Me Akurdi",
    "Akurdi Outstation Taxi",
    "Akurdi Corporate Taxi",
    "Akurdi Taxi Deals",
    "Akurdi City Taxi",
    "Akurdi Family Taxi Service",
    "Taxi Booking Online Akurdi"
  ],
  "telephone": "+91-XXXXXXXXXX"
};




    return (
        <div>
<Helmet>
  <title>Cab Service in Akurdi Pune | Reliable Taxi Service Akurdi</title>
  <meta
    name="description"
    content="Reliable and affordable cab service in Akurdi Pune offering local, airport, outstation, corporate, and family taxi services with professional drivers available for easy booking."
  />
  <meta
    name="keywords"
    content="Akurdi Cab Service, Taxi Service Akurdi Pune, Cab Booking Akurdi, Akurdi Local Taxi, Affordable Taxi Akurdi Pune, Akurdi Taxi with Driver, Akurdi Airport Taxi, Cab Rental Akurdi, Cab Service Near Me Akurdi, Akurdi Outstation Taxi, Akurdi Corporate Taxi, Akurdi Taxi Deals, Akurdi City Taxi, Akurdi Family Taxi Service, Taxi Booking Online Akurdi"
  />
  <script type="application/ld+json">
    {JSON.stringify(akurdiTaxiSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/75.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinakurdipune;